import React from 'react'
import botIcon from '../../../../images/jarvis/png/chatbot.png'
import cancelIcon from '../../../../images/jarvis/svg/cancel_close.svg'
import Jarvis_Bg from '../../../../images/jarvis/png/jarvis_bg.png'
import { Link } from 'react-router-dom'

const Header = ({ children }) => {
    return (
        <>
            <style>
                {`
                    .header-nav {
                        background-image: url("../../../../images/jarvis/png/jarvis_bg.png");
                        background-repeat: no-repeat;
                        background-size: cover;
                    }
                `}
            </style>
            <div
                className='header-nav'
                style={{
                    backgroundImage: `url(${Jarvis_Bg})`,
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    position: "fixed",
                    top: 0,
                    left: 0,
                    width: "100%",
                    maxWidth: "550px",
                    zIndex: 99,
                }}>
                <div
                    style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        marginTop: "10px",
                        marginLeft: "10px",
                        marginRight: "15px"
                    }}
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            gap: "18px"
                        }}
                    >
                        <div
                            style={{
                                backgroundColor: "#fff",
                                borderRadius: "50%",
                                padding: "3px"
                            }}
                        >
                            <img
                                src={botIcon}
                                height={32}
                                alt='cancel-icon'
                            />
                        </div>
                        <div>
                            <p
                                style={{
                                    fontSize: "1.4em",
                                    fontWeight: 450,
                                    color: "#fff",
                                    margin: 0
                                }}
                            >
                                Aacharya
                            </p>
                        </div>
                    </div>
                    <div>
                        <Link to="/distributor-home">
                            <div
                                className='cursor-pointer'
                                style={{
                                    backgroundColor: "#707070",
                                    padding: "0px 6px 3px 6px",
                                    borderRadius: "7px",
                                    border: "1px solid #fff",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center"
                                }}
                            >
                                <div>
                                    <img
                                        src={cancelIcon}
                                        alt='cancel-icon'
                                    />
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
                <div
                    style={{
                        marginTop: "7px"
                    }}
                >
                    <hr
                        style={{
                            height: "1px",
                            borderWidth: 0,
                            backgroundColor: "#c5c3c2",
                            margin: 0
                        }}
                    />
                </div>
            </div>
            <div
                className='w-100'
                style={{
                    marginTop: "50px",
                    // overflowY: "scroll",
                    // overflowX: "hidden",
                    height: "calc(100vh - 500px)"
                }}
            >
                {children}
            </div>
        </>
    )
}

export default Header